import { render } from "./othernews.vue?vue&type=template&id=e46ea64a&scoped=true"
import script from "./othernews.vue?vue&type=script&lang=js"
export * from "./othernews.vue?vue&type=script&lang=js"

import "./othernews.vue?vue&type=style&index=0&id=e46ea64a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e46ea64a"]])

export default __exports__